import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Header from'../../components/Header/Header';
import Book from '../../components/Books/Books';
import './Home.css'
import { DataContext } from '../../App';

const Home = () => {


    
    const [books,setBooks] = useState([]);
    const[cart,setCart] = useState([]);

    // const[cart,setCart] = useContext(DataContext);

    useEffect(() => {

        fetch ('https://cryptic-plains-44743.herokuapp.com/books')
        .then(res => res.json())
        .then(data => setBooks (data))


    },[])

    const handleAddBook = (book) => {


        console.log('book added', book)
        const newCart = [...cart, cart]
        setCart (newCart)
    }







    return (
        <div className="container">

        <Header></Header>

       <div className="book-part">
       
       {
        books.map(book => <Book 
        book={book}
        key={book._id}
        handleAddBook={handleAddBook}
       


         ></Book>)
       }
       </div>     
        </div>
    );
};

export default Home;